import styled from "@emotion/styled";
import { generateToastStyles } from "../../utils";
import { ToastAction, ToastType } from "./Toast.types";
import { colorGuide } from "../../theme/colors";
import { TOAST_Z_INDEX } from "../../utils/constants";
import { keyframes } from "@emotion/react";

// Define animation using `keyframes`
const toastAnimation = keyframes`
    0% {
        bottom: 0;
    }
    3.3% {
        bottom: 80px;
    }
    96.7% {
        bottom: 80px;
    }
    100% {
        bottom: 0;
    }
`;

const reelSwipeHintToastAnimation = keyframes`
    0% {
        bottom: 0;
    }
    3.3% {
        bottom: 220px;
    }
    96.7% {
        bottom: 220px;
    }
    100% {
        bottom: 0;
    }
`;

// Define props interface
interface ToastContainerProps {
  action: ToastAction;
  type: ToastType;
}

export const StyledToastContainer = styled.div<ToastContainerProps>`
  ${({ action, type }) => generateToastStyles({ action, type })}
  ${({ type }) =>
    type === "reel-swipe-hint"
      ? `
        gap: 4px;
      `
      : ""}
  padding: 4px 20px;
  border-radius: 20px;
  align-items: center;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  // max-width: 408px;
  width: max-content;
  max-width: 75%;
  z-index: ${TOAST_Z_INDEX};
  animation: ${({ type }) =>
      type === "reel-swipe-hint" ? reelSwipeHintToastAnimation : toastAnimation}
    3s ease-in-out forwards;
`;

export const ToastIcon = styled.i`
  color: ${colorGuide.lightComponents.toastMessage.iconColor};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
`;

export const ToastButton = styled.button<{ toastType: ToastType }>`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  color: ${({ toastType }) =>
    toastType === "neutral"
      ? colorGuide.lightComponents.toastMessage.neutral.buttonColor
      : colorGuide.lightComponents.toastMessage.buttonColor};
`;

export const ToastIconContainer = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
